var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaqIcon9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 57,
    viewBox: "0 0 102 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 12.9565C60 16.0205 56.9957 19.0103 51.577 21.2741C46.2219 23.5111 38.7709 24.913 30.5 24.913C22.2291 24.913 14.7781 23.5111 9.42298 21.2741C4.00426 19.0103 1 16.0205 1 12.9565C1 9.89255 4.00426 6.90265 9.42298 4.63897C14.7781 2.4019 22.2291 1 30.5 1C38.7709 1 46.2219 2.4019 51.577 4.63897C56.9957 6.90265 60 9.89255 60 12.9565Z",
    fill: "white",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.435 22.5488V15.3194V14.9578H57.4229C56.9912 8.53699 45.1027 3.39062 30.5002 3.39062C15.8977 3.39062 4.00923 8.53699 3.57755 14.9578H3.56543V15.3194V22.5488V22.9104H3.57755C4.00923 29.3311 15.8977 34.4776 30.5002 34.4776C45.1027 34.4776 56.9912 29.3311 57.4229 22.9104H57.435V22.5488Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 22.5239C60 25.5879 56.9957 28.5777 51.577 30.8414C46.2219 33.0785 38.7709 34.4804 30.5 34.4804C22.2291 34.4804 14.7781 33.0785 9.42298 30.8414C4.00426 28.5777 1 25.5879 1 22.5239C1 19.4599 4.00426 16.47 9.42298 14.2064C14.7781 11.9693 22.2291 10.5674 30.5 10.5674C38.7709 10.5674 46.2219 11.9693 51.577 14.2064C56.9957 16.47 60 19.4599 60 22.5239Z",
    fill: "white",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.739 22.9354V22.9367V29.285V30.1931H49.6604C48.7758 35.2778 40.5351 39.2624 30.4999 39.2624C20.4646 39.2624 12.2239 35.2778 11.3393 30.1931H11.2607V29.285V22.9367V22.9354C11.2607 17.425 19.8744 12.958 30.4999 12.958C41.1254 12.958 49.739 17.425 49.739 22.9354Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.739 24.9132C49.739 26.6889 47.8651 28.4809 44.3124 29.8653C40.8162 31.2276 35.9336 32.0871 30.4999 32.0871C25.0661 32.0871 20.1835 31.2276 16.6874 29.8653C13.1347 28.4809 11.2607 26.6889 11.2607 24.9132C11.2607 23.1374 13.1347 21.3454 16.6874 19.961C20.1835 18.5987 25.0661 17.7393 30.4999 17.7393C35.9336 17.7393 40.8162 18.5987 44.3124 19.961C47.8651 21.3454 49.739 23.1374 49.739 24.9132Z",
    fill: "white",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2173 56H42.0434",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6958 51.2188H52.3045",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9565 46.4326H49.7392",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8262 44.042H36.9131",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.739 29.6944C49.739 31.4702 47.8651 33.2622 44.3124 34.6466C40.8162 36.0089 35.9336 36.8683 30.4999 36.8683C25.0661 36.8683 20.1835 36.0089 16.6874 34.6466C13.1347 33.2622 11.2607 31.4702 11.2607 29.6944C11.2607 27.9187 13.1347 26.1266 16.6874 24.7423C20.1835 23.38 25.0661 22.5205 30.4999 22.5205C35.9336 22.5205 40.8162 23.38 44.3124 24.7423C47.8651 26.1266 49.739 27.9187 49.739 29.6944Z",
    fill: "white",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4785 30.8897C39.4785 31.7208 38.6871 32.6062 37.0295 33.3203C35.3997 34.0225 33.0929 34.4766 30.5002 34.4766C27.9075 34.4766 25.6007 34.0225 23.9709 33.3203C22.3134 32.6062 21.522 31.7208 21.522 30.8897C21.522 30.0586 22.3134 29.1732 23.9709 28.4591C25.6007 27.7569 27.9075 27.3027 30.5002 27.3027C33.0929 27.3027 35.3997 27.7569 37.0295 28.4591C38.6871 29.1732 39.4785 30.0586 39.4785 30.8897Z",
    fill: "white",
    stroke: "#475467",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 16.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "white",
    stroke: "#D0D5DD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0002 38.8008C87.0002 38.8008 93.6668 35.8008 93.6668 31.3008V26.0508L87.0002 23.8008L80.3335 26.0508V31.3008C80.3335 35.8008 87.0002 38.8008 87.0002 38.8008Z",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3332 29.1992L85.7498 33.3242L83.6665 31.4492",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon9);
export default __webpack_public_path__ + "static/media/faq-icon9.28b1abe914dfde59e08c0104ef9f44b4.svg";
export { ForwardRef as ReactComponent };